<template>
  <div class="spinner-container" :class="{ 'inline': inline }">
    <div class="loader"></div>
    <span v-if="text" class="spinner-text" :style="textStyle">{{ text }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  size: {
    type: String,
    default: '20px'
  },
  color: {
    type: String,
    default: '#ffffff'
  },
  text: {
    type: String,
    default: ''
  },
  textColor: {
    type: String,
    default: '#ffffff'
  },
  inline: {
    type: Boolean,
    default: false
  }
})

const spinnerStyle = computed(() => ({
  width: props.size,
  height: props.size,
  borderColor: props.color,
  borderTopColor: 'transparent'
}))

const textStyle = computed(() => ({
  color: props.textColor
}))
</script>

<style scoped>
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  height: 4rem;
}

.loader {
  width: 17px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #000;
  display: grid;
  animation: l22-0 2s infinite linear;
}
.loader:before,
.loader:after {
  content: "";
  grid-area: 1/1;
  margin: 15%;
  border-radius: 50%;
  background: inherit;
  transform: rotate(0deg) translate(150%);
  animation: l22 1s infinite;
}
.loader:after {
  animation-delay: -.5s
}
@keyframes l22-0 {
  100% {transform: rotate(1turn)}
}
@keyframes l22 {
  100% {transform: rotate(1turn) translate(150%)}
}
.spinner-text {
  font-size: 0.875rem;
  font-weight: 500;
}
</style>